import React from 'react';
import ChildFutureReadyTest from '../components/ChildFutureReadyTest';

const ChildFutureReady = () => (
  <div className="space-y-4" data-testid="child-future-ready-page">
    <ChildFutureReadyTest />
  </div>
);

export default ChildFutureReady;
